class Init {
  constructor() {
    this.isSkip = false;
    this.isDefaultFirst = true;
    this.hHeight = 0;
  }
  init() {
    this.isSkip = document.body.classList.contains('is-skip') ? true : false;
    // ロケーションハッシュ
    window.addEventListener('load', () => {
      if (location.hash !== '' && !this.isNoCueOffset) {
        const hash = location.hash.replace('#', '');
        const target = document.getElementById(hash);
        const offset = -Number(this.hHeight);
        const targetPos =
          target.getBoundingClientRect().top + window.pageYOffset + offset;
        const anime = new azlib.anime({
          targets: 'html, body',
          scrollTop: targetPos,
          duration: 10,
          easing: 'easeInQuad',
          complete: () => {
            const newTargetPos =
              target.getBoundingClientRect().top + window.pageYOffset + offset;
            if (targetPos !== newTargetPos) {
              new azlib.anime({
                targets: 'html, body',
                scrollTop: newTargetPos,
                duration: 10,
                easing: 'linear',
              });
            }
          },
        });
      }
    });

    this.adjust();
    this.adjust().then(() => this.runIntro());
  }
  async adjust() {
    new Promise((resolve, reject) => {
    if (!document.body.classList.contains('noGnav')) {
        const siteHeader = document.getElementById('siteHeader');
        this.hHeight = siteHeader ? siteHeader.clientHeight : 0;
      } else {
        this.hHeight = 0;
      }
      let targetPos = this.hHeight;
      util.sScroll(-targetPos, 700, 'cubicBezier(0.11, 0, 0.5, 0)');
      this.adjustHeader();
      resolve();
    });
  }
  runIntro() {
    if (this.isSkip) return;
    new azlib.anime({
      targets: '#wrapper',
      opacity: 1,
      delay: 300,
      duration: 250,
      easing: 'linear',
      complete: (anim) => {
        this.isDefaultFirst = false;
      },
    });
  }
  adjustHeader() { }
}

/**
 * インスタンス化
 */
const util = new azlib.Utilities({
});
const init = new Init();

/**
 * 実行
 */
document.addEventListener('DOMContentLoaded', () => {
  util.init();
  init.init();
});
